exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".labelText-2d-JT{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:20px}.labelText-2d-JT:last-child{margin-bottom:0}.label-eXUQQ{color:#9196af;white-space:nowrap;display:-webkit-box;display:-ms-flexbox;display:flex;height:10px}.label_margin_yes-ZSSeh{margin-right:10px}.text-3S7gh{color:#fff;overflow:hidden;overflow-wrap:break-word;word-break:break-word}.theme-dark .text-3S7gh{color:#fff}.theme-light .text-3S7gh{color:#212121}.tooltipContainer-GyFnn{display:inline-block;margin-left:10px}.tooltipContainer-GyFnn .tooltip-3vMbA,.tooltipContainer-GyFnn:hover .tooltip-3vMbA{width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:300px}.tooltipText-178l4 p{margin:0;padding:0}", ""]);

// exports
exports.locals = {
	"labelText": "labelText-2d-JT",
	"label": "label-eXUQQ",
	"label_margin_yes": "label_margin_yes-ZSSeh",
	"text": "text-3S7gh",
	"tooltipContainer": "tooltipContainer-GyFnn",
	"tooltip": "tooltip-3vMbA",
	"tooltipText": "tooltipText-178l4"
};